{
  "title": "Power Word: Pain",
  "source": "Xanathar's Guide to Everything",
  "levelAndSchool": "7th-level enchantment",
  "level": 7,
  "castingTime": "1 action",
  "range": "60 feet",
  "components": "V",
  "duration": "Instantaneous",
  "description": [
    "You speak a word of power that causes waves of intense pain to assail one creature you can see within range. If the target has 100 hit points or fewer, it is subject to crippling pain. Otherwise, the spell has no effect on it. A target is also unaffected if it is immune to being charmed.",
    "While the target is affected by crippling pain, any speed it has can be no higher than 10 feet. The target also has disadvantage on attack rolls, ability checks, and saving throws, other than Constitution saving throws. Finally, if the target tries to cast a spell, it must first succeed on a Constitution saving throw, or the casting fails and the spell is wasted.",
    "A target suffering this pain can make a Constitution saving throw at the end of each of its turns. On a successful save, the pain ends."
  ],
  "spellLists": ["sorcerer", "warlock", "wizard"]
}
